// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"572":"942f985d","594":"87e28f65","809":"e54a56e8","836":"5a0b242c"}[chunkId] + ".chunk.js";
};